{
  "countries": {
    "A1": {
      "display": "Anonymous Proxy",
      "userSelectable": false
    },
    "A2": {
      "display": "Satellite Provider",
      "userSelectable": false
    },
    "AC": {
      "display": "Ascension Island",
      "userSelectable": true
    },
    "AD": {
      "display": "Andorra",
      "userSelectable": true
    },
    "AE": {
      "display": "United Arab Emirates",
      "userSelectable": true
    },
    "AF": {
      "display": "Afghanistan",
      "userSelectable": true
    },
    "AG": {
      "display": "Antigua and Barbuda",
      "userSelectable": true
    },
    "AI": {
      "display": "Anguilla",
      "userSelectable": true
    },
    "AL": {
      "display": "Albania",
      "userSelectable": true
    },
    "AM": {
      "display": "Armenia",
      "userSelectable": true
    },
    "AN": {
      "display": "Netherlands Antilles",
      "userSelectable": false
    },
    "AO": {
      "display": "Angola",
      "userSelectable": true
    },
    "AP": {
      "display": "Asia/Pacific Region",
      "userSelectable": false
    },
    "AQ": {
      "display": "Antarctica",
      "userSelectable": true
    },
    "AR": {
      "display": "Argentina",
      "userSelectable": true,
      "region": "foundation"
    },
    "AS": {
      "display": "American Samoa",
      "userSelectable": true
    },
    "AT": {
      "display": "Austria",
      "userSelectable": true
    },
    "AU": {
      "display": "Australia",
      "userSelectable": true,
      "region": "pbc"
    },
    "AW": {
      "display": "Aruba",
      "userSelectable": true
    },
    "AX": {
      "display": "Åland Islands",
      "userSelectable": true
    },
    "AZ": {
      "display": "Azerbaijan",
      "userSelectable": true
    },
    "BA": {
      "display": "Bosnia and Herzegovina",
      "userSelectable": true
    },
    "BB": {
      "display": "Barbados",
      "userSelectable": true
    },
    "BD": {
      "display": "Bangladesh",
      "userSelectable": true
    },
    "BE": {
      "display": "Belgium",
      "userSelectable": true
    },
    "BF": {
      "display": "Burkina Faso",
      "userSelectable": true
    },
    "BG": {
      "display": "Bulgaria",
      "userSelectable": true
    },
    "BH": {
      "display": "Bahrain",
      "userSelectable": true
    },
    "BI": {
      "display": "Burundi",
      "userSelectable": true
    },
    "BJ": {
      "display": "Benin",
      "userSelectable": true
    },
    "BL": {
      "display": "Saint Barthélemy",
      "userSelectable": true
    },
    "BM": {
      "display": "Bermuda",
      "userSelectable": true
    },
    "BN": {
      "display": "Brunei Darussalam",
      "userSelectable": true
    },
    "BO": {
      "display": "Bolivia, Plurinational State of",
      "userSelectable": true,
      "region": "foundation"
    },
    "BQ": {
      "display": "Bonaire, Sint Eustatius and Saba",
      "userSelectable": true
    },
    "BR": {
      "display": "Brazil",
      "userSelectable": true,
      "region": "foundation"
    },
    "BS": {
      "display": "Bahamas",
      "userSelectable": true
    },
    "BT": {
      "display": "Bhutan",
      "userSelectable": true
    },
    "BV": {
      "display": "Bouvet Island",
      "userSelectable": true
    },
    "BW": {
      "display": "Botswana",
      "userSelectable": true
    },
    "BY": {
      "display": "Belarus",
      "userSelectable": true
    },
    "BZ": {
      "display": "Belize",
      "userSelectable": true
    },
    "CA": {
      "display": "Canada",
      "userSelectable": true,
      "region": "northamerica"
    },
    "CC": {
      "display": "Cocos (Keeling) Islands",
      "userSelectable": true
    },
    "CD": {
      "display": "Congo, the Democratic Republic of the",
      "userSelectable": true
    },
    "CE": {
      "display": "Ceuta",
      "userSelectable": false
    },
    "CF": {
      "display": "Central African Republic",
      "userSelectable": true
    },
    "CG": {
      "display": "Congo",
      "userSelectable": true
    },
    "CH": {
      "display": "Switzerland",
      "userSelectable": true
    },
    "CI": {
      "display": "Cote d'Ivoire",
      "userSelectable": true
    },
    "CK": {
      "display": "Cook Islands",
      "userSelectable": true
    },
    "CL": {
      "display": "Chile",
      "userSelectable": true,
      "region": "foundation"
    },
    "CM": {
      "display": "Cameroon",
      "userSelectable": true
    },
    "CN": {
      "display": "China",
      "userSelectable": true
    },
    "CO": {
      "display": "Colombia",
      "userSelectable": true,
      "region": "foundation"
    },
    "CP": {
      "display": "Clipperton Island",
      "userSelectable": true
    },
    "CQ": {
      "__comment__": "Added within cldr 7.4.0, needs to be added to other repos before being user-selectable",
      "display": "Sark",
      "userSelectable": false
    },
    "CR": {
      "display": "Costa Rica",
      "userSelectable": true,
      "region": "foundation"
    },
    "CS": {
      "__comment__": "Used to be Czechoslovakia",
      "display": "Czech Republic",
      "userSelectable": false
    },
    "CU": {
      "display": "Cuba",
      "userSelectable": true
    },
    "CV": {
      "display": "Cape Verde",
      "userSelectable": true
    },
    "CW": {
      "display": "Curaçao",
      "userSelectable": true
    },
    "CX": {
      "display": "Christmas Island",
      "userSelectable": true
    },
    "CY": {
      "display": "Cyprus",
      "userSelectable": true
    },
    "CZ": {
      "display": "Czech Republic",
      "userSelectable": true
    },
    "DE": {
      "display": "Germany",
      "userSelectable": true,
      "region": "foundation"
    },
    "DG": {
      "display": "Diego Garcia",
      "userSelectable": true
    },
    "DJ": {
      "display": "Djibouti",
      "userSelectable": true
    },
    "DK": {
      "display": "Denmark",
      "userSelectable": true
    },
    "DM": {
      "display": "Dominica",
      "userSelectable": true
    },
    "DO": {
      "display": "Dominican Republic",
      "userSelectable": true,
      "region": "foundation"
    },
    "DZ": {
      "display": "Algeria",
      "userSelectable": true
    },
    "EA": {
      "__comment__": "Might be split into CE/ES-CE/ES-ML at some point",
      "display": "Ceuta & Melilla",
      "userSelectable": true
    },
    "EC": {
      "display": "Ecuador",
      "userSelectable": true,
      "region": "foundation"
    },
    "EE": {
      "display": "Estonia",
      "userSelectable": true
    },
    "EG": {
      "display": "Egypt",
      "userSelectable": true
    },
    "EH": {
      "display": "Western Sahara",
      "userSelectable": true
    },
    "ER": {
      "display": "Eritrea",
      "userSelectable": true
    },
    "ES": {
      "display": "Spain",
      "userSelectable": true,
      "region": "pbc"
    },
    "ET": {
      "display": "Ethiopia",
      "userSelectable": true
    },
    "EU": {
      "display": "European Union",
      "userSelectable": false
    },
    "FI": {
      "display": "Finland",
      "userSelectable": true
    },
    "FJ": {
      "display": "Fiji",
      "userSelectable": true
    },
    "FK": {
      "display": "Falkland Islands (Malvinas)",
      "userSelectable": true
    },
    "FM": {
      "display": "Micronesia, Federated States of",
      "userSelectable": true
    },
    "FO": {
      "display": "Faroe Islands",
      "userSelectable": true
    },
    "FR": {
      "display": "France",
      "userSelectable": true,
      "region": "pbc"
    },
    "GA": {
      "display": "Gabon",
      "userSelectable": true
    },
    "GB": {
      "display": "United Kingdom",
      "userSelectable": true,
      "region": "pbc"
    },
    "GD": {
      "display": "Grenada",
      "userSelectable": true
    },
    "GE": {
      "display": "Georgia",
      "userSelectable": true
    },
    "GF": {
      "display": "French Guiana",
      "userSelectable": true
    },
    "GG": {
      "display": "Guernsey",
      "userSelectable": true
    },
    "GH": {
      "display": "Ghana",
      "userSelectable": true
    },
    "GI": {
      "display": "Gibraltar",
      "userSelectable": true
    },
    "GL": {
      "display": "Greenland",
      "userSelectable": true
    },
    "GM": {
      "display": "Gambia",
      "userSelectable": true
    },
    "GN": {
      "display": "Guinea",
      "userSelectable": true
    },
    "GP": {
      "display": "Guadeloupe",
      "userSelectable": true
    },
    "GQ": {
      "display": "Equatorial Guinea",
      "userSelectable": true
    },
    "GR": {
      "display": "Greece",
      "userSelectable": true
    },
    "GS": {
      "display": "South Georgia and the South Sandwich Islands",
      "userSelectable": true
    },
    "GT": {
      "display": "Guatemala",
      "userSelectable": true,
      "region": "foundation"
    },
    "GU": {
      "display": "Guam",
      "userSelectable": true
    },
    "GW": {
      "display": "Guinea-Bissau",
      "userSelectable": true
    },
    "GY": {
      "display": "Guyana",
      "userSelectable": true
    },
    "HK": {
      "display": "Hong Kong",
      "userSelectable": true
    },
    "HM": {
      "display": "Heard Island and McDonald Islands",
      "userSelectable": true
    },
    "HN": {
      "display": "Honduras",
      "userSelectable": true,
      "region": "foundation"
    },
    "HR": {
      "display": "Croatia",
      "userSelectable": true
    },
    "HT": {
      "display": "Haiti",
      "userSelectable": true
    },
    "HU": {
      "display": "Hungary",
      "userSelectable": true
    },
    "IC": {
      "__comment__": "Also known as ES-CN",
      "display": "Canary Islands",
      "userSelectable": true
    },
    "ID": {
      "display": "Indonesia",
      "userSelectable": true,
      "region": "foundation"
    },
    "IE": {
      "display": "Ireland",
      "userSelectable": true
    },
    "IL": {
      "display": "Israel",
      "userSelectable": true
    },
    "IM": {
      "display": "Isle of Man",
      "userSelectable": true
    },
    "IN": {
      "display": "India",
      "userSelectable": true,
      "region": "foundation"
    },
    "IO": {
      "display": "British Indian Ocean Territory",
      "userSelectable": true
    },
    "IQ": {
      "display": "Iraq",
      "userSelectable": true
    },
    "IR": {
      "display": "Iran, Islamic Republic of",
      "userSelectable": true
    },
    "IS": {
      "display": "Iceland",
      "userSelectable": true
    },
    "IT": {
      "display": "Italy",
      "userSelectable": true,
      "region": "pbc"
    },
    "JE": {
      "display": "Jersey",
      "userSelectable": true
    },
    "JM": {
      "display": "Jamaica",
      "userSelectable": true
    },
    "JO": {
      "display": "Jordan",
      "userSelectable": true
    },
    "JP": {
      "display": "Japan",
      "userSelectable": true,
      "region": "foundation"
    },
    "KE": {
      "display": "Kenya",
      "userSelectable": true,
      "region": "foundation"
    },
    "KG": {
      "display": "Kyrgyzstan",
      "userSelectable": true
    },
    "KH": {
      "display": "Cambodia",
      "userSelectable": true
    },
    "KI": {
      "display": "Kiribati",
      "userSelectable": true
    },
    "KM": {
      "display": "Comoros",
      "userSelectable": true
    },
    "KN": {
      "display": "Saint Kitts and Nevis",
      "userSelectable": true
    },
    "KP": {
      "display": "Korea, Democratic People's Republic of",
      "userSelectable": true
    },
    "KR": {
      "display": "Korea, Republic of",
      "userSelectable": true
    },
    "KV": {
      "display": "Kosovo",
      "userSelectable": false
    },
    "KW": {
      "display": "Kuwait",
      "userSelectable": true
    },
    "KY": {
      "display": "Cayman Islands",
      "userSelectable": true
    },
    "KZ": {
      "display": "Kazakhstan",
      "userSelectable": true
    },
    "LA": {
      "display": "Lao People's Democratic Republic",
      "userSelectable": true
    },
    "LB": {
      "display": "Lebanon",
      "userSelectable": true
    },
    "LC": {
      "display": "Saint Lucia",
      "userSelectable": true
    },
    "LI": {
      "display": "Liechtenstein",
      "userSelectable": true
    },
    "LK": {
      "display": "Sri Lanka",
      "userSelectable": true
    },
    "LR": {
      "display": "Liberia",
      "userSelectable": true
    },
    "LS": {
      "display": "Lesotho",
      "userSelectable": true
    },
    "LT": {
      "display": "Lithuania",
      "userSelectable": true
    },
    "LU": {
      "display": "Luxembourg",
      "userSelectable": true
    },
    "LV": {
      "display": "Latvia",
      "userSelectable": true
    },
    "LY": {
      "display": "Libya",
      "userSelectable": true
    },
    "MA": {
      "display": "Morocco",
      "userSelectable": true
    },
    "MC": {
      "display": "Monaco",
      "userSelectable": true
    },
    "MD": {
      "display": "Moldova, Republic of",
      "userSelectable": true
    },
    "ME": {
      "display": "Montenegro",
      "userSelectable": true
    },
    "MF": {
      "display": "Saint Martin (French part)",
      "userSelectable": true
    },
    "MG": {
      "display": "Madagascar",
      "userSelectable": true
    },
    "MH": {
      "display": "Marshall Islands",
      "userSelectable": true
    },
    "MK": {
      "display": "Macedonia, the former Yugoslav Republic of",
      "userSelectable": true
    },
    "ML": {
      "display": "Mali",
      "userSelectable": true
    },
    "MM": {
      "display": "Myanmar",
      "userSelectable": true
    },
    "MN": {
      "display": "Mongolia",
      "userSelectable": true
    },
    "MO": {
      "display": "Macao",
      "userSelectable": true
    },
    "MP": {
      "display": "Northern Mariana Islands",
      "userSelectable": true
    },
    "MQ": {
      "display": "Martinique",
      "userSelectable": true
    },
    "MR": {
      "display": "Mauritania",
      "userSelectable": true
    },
    "MS": {
      "display": "Montserrat",
      "userSelectable": true
    },
    "MT": {
      "display": "Malta",
      "userSelectable": true
    },
    "MU": {
      "display": "Mauritius",
      "userSelectable": true
    },
    "MV": {
      "display": "Maldives",
      "userSelectable": true
    },
    "MW": {
      "display": "Malawi",
      "userSelectable": true
    },
    "MX": {
      "display": "Mexico",
      "userSelectable": true,
      "region": "foundation"
    },
    "MY": {
      "display": "Malaysia",
      "userSelectable": true,
      "region": "foundation"
    },
    "MZ": {
      "display": "Mozambique",
      "userSelectable": true
    },
    "NA": {
      "display": "Namibia",
      "userSelectable": true
    },
    "NC": {
      "display": "New Caledonia",
      "userSelectable": true
    },
    "NE": {
      "display": "Niger",
      "userSelectable": true
    },
    "NF": {
      "display": "Norfolk Island",
      "userSelectable": true
    },
    "NG": {
      "display": "Nigeria",
      "userSelectable": true,
      "region": "foundation"
    },
    "NI": {
      "display": "Nicaragua",
      "userSelectable": true,
      "region": "foundation"
    },
    "NL": {
      "display": "Netherlands",
      "userSelectable": true
    },
    "NO": {
      "display": "Norway",
      "userSelectable": true
    },
    "NP": {
      "display": "Nepal",
      "userSelectable": true
    },
    "NR": {
      "display": "Nauru",
      "userSelectable": true
    },
    "NT": {
      "display": "Neutral Zone",
      "userSelectable": false
    },
    "NU": {
      "display": "Niue",
      "userSelectable": true
    },
    "NZ": {
      "display": "New Zealand",
      "userSelectable": true
    },
    "OM": {
      "display": "Oman",
      "userSelectable": true
    },
    "PA": {
      "display": "Panama",
      "userSelectable": true,
      "region": "foundation"
    },
    "PE": {
      "display": "Peru",
      "userSelectable": true,
      "region": "foundation"
    },
    "PF": {
      "display": "French Polynesia",
      "userSelectable": true
    },
    "PG": {
      "display": "Papua New Guinea",
      "userSelectable": true
    },
    "PH": {
      "display": "Philippines",
      "userSelectable": true
    },
    "PK": {
      "display": "Pakistan",
      "userSelectable": true
    },
    "PL": {
      "display": "Poland",
      "userSelectable": true
    },
    "PM": {
      "display": "Saint Pierre and Miquelon",
      "userSelectable": true
    },
    "PN": {
      "display": "Pitcairn",
      "userSelectable": true
    },
    "PR": {
      "display": "Puerto Rico",
      "userSelectable": true,
      "region": "foundation"
    },
    "PS": {
      "display": "Palestinian Territory, Occupied",
      "userSelectable": true
    },
    "PT": {
      "display": "Portugal",
      "userSelectable": true
    },
    "PW": {
      "display": "Palau",
      "userSelectable": true
    },
    "PY": {
      "display": "Paraguay",
      "userSelectable": true,
      "region": "foundation"
    },
    "QA": {
      "display": "Qatar",
      "userSelectable": true
    },
    "RE": {
      "display": "Reunion",
      "userSelectable": true
    },
    "RO": {
      "display": "Romania",
      "userSelectable": true
    },
    "RS": {
      "display": "Serbia",
      "userSelectable": true
    },
    "RU": {
      "display": "Russian Federation",
      "userSelectable": true,
      "region": "pbc"
    },
    "RW": {
      "display": "Rwanda",
      "userSelectable": true
    },
    "SA": {
      "display": "Saudi Arabia",
      "userSelectable": true
    },
    "SB": {
      "display": "Solomon Islands",
      "userSelectable": true
    },
    "SC": {
      "display": "Seychelles",
      "userSelectable": true
    },
    "SD": {
      "display": "Sudan",
      "userSelectable": true
    },
    "SE": {
      "display": "Sweden",
      "userSelectable": true
    },
    "SG": {
      "display": "Singapore",
      "userSelectable": true
    },
    "SH": {
      "display": "Saint Helena, Ascension and Tristan da Cunha",
      "userSelectable": true
    },
    "SI": {
      "display": "Slovenia",
      "userSelectable": true
    },
    "SJ": {
      "display": "Svalbard and Jan Mayen",
      "userSelectable": true
    },
    "SK": {
      "display": "Slovakia",
      "userSelectable": true
    },
    "SL": {
      "display": "Sierra Leone",
      "userSelectable": true
    },
    "SM": {
      "display": "San Marino",
      "userSelectable": true
    },
    "SN": {
      "display": "Senegal",
      "userSelectable": true
    },
    "SO": {
      "display": "Somalia",
      "userSelectable": true
    },
    "SR": {
      "display": "Suriname",
      "userSelectable": true
    },
    "SS": {
      "display": "South Sudan",
      "userSelectable": true
    },
    "ST": {
      "display": "Sao Tome and Principe",
      "userSelectable": true
    },
    "SU": {
      "__comment__": "Used to be Soviet Union",
      "display": "Russia",
      "userSelectable": false
    },
    "SV": {
      "display": "El Salvador",
      "userSelectable": true,
      "region": "foundation"
    },
    "SX": {
      "display": "Sint Maarten (Dutch part)",
      "userSelectable": true
    },
    "SY": {
      "display": "Syrian Arab Republic",
      "userSelectable": true
    },
    "SZ": {
      "display": "Swaziland",
      "userSelectable": true
    },
    "TA": {
      "display": "Tristan da Cunha",
      "userSelectable": true
    },
    "TC": {
      "display": "Turks and Caicos Islands",
      "userSelectable": true
    },
    "TD": {
      "display": "Chad",
      "userSelectable": true
    },
    "TF": {
      "display": "French Southern Territories",
      "userSelectable": true
    },
    "TG": {
      "display": "Togo",
      "userSelectable": true
    },
    "TH": {
      "display": "Thailand",
      "userSelectable": true,
      "region": "foundation"
    },
    "TJ": {
      "display": "Tajikistan",
      "userSelectable": true
    },
    "TK": {
      "display": "Tokelau",
      "userSelectable": true
    },
    "TL": {
      "display": "East Timor",
      "userSelectable": true
    },
    "TM": {
      "display": "Turkmenistan",
      "userSelectable": true
    },
    "TN": {
      "display": "Tunisia",
      "userSelectable": true
    },
    "TO": {
      "display": "Tonga",
      "userSelectable": true
    },
    "TR": {
      "display": "Turkey",
      "userSelectable": true,
      "region": "pbc"
    },
    "TT": {
      "display": "Trinidad and Tobago",
      "userSelectable": true
    },
    "TV": {
      "display": "Tuvalu",
      "userSelectable": true
    },
    "TW": {
      "display": "Taiwan",
      "userSelectable": true
    },
    "TZ": {
      "display": "Tanzania, United Republic of",
      "userSelectable": true
    },
    "UA": {
      "display": "Ukraine",
      "userSelectable": true
    },
    "UG": {
      "display": "Uganda",
      "userSelectable": true
    },
    "UK": {
      "display": "United Kingdom",
      "userSelectable": false
    },
    "UM": {
      "display": "United States Minor Outlying Islands",
      "userSelectable": true
    },
    "US": {
      "display": "United States",
      "userSelectable": true,
      "region": "northamerica"
    },
    "UY": {
      "display": "Uruguay",
      "userSelectable": true,
      "region": "foundation"
    },
    "UZ": {
      "display": "Uzbekistan",
      "userSelectable": true
    },
    "VA": {
      "display": "Holy See (Vatican City State)",
      "userSelectable": true
    },
    "VC": {
      "display": "Saint Vincent and the Grenadines",
      "userSelectable": true
    },
    "VE": {
      "display": "Venezuela, Bolivarian Republic of",
      "userSelectable": true,
      "region": "foundation"
    },
    "VG": {
      "display": "Virgin Islands, British",
      "userSelectable": true
    },
    "VI": {
      "display": "Virgin Islands, U.S.",
      "userSelectable": true
    },
    "VN": {
      "display": "Viet Nam",
      "userSelectable": true
    },
    "VU": {
      "display": "Vanuatu",
      "userSelectable": true
    },
    "WF": {
      "display": "Wallis and Futuna",
      "userSelectable": true
    },
    "WS": {
      "display": "Samoa",
      "userSelectable": true
    },
    "XK": {
      "display": "Kosovo",
      "userSelectable": true
    },
    "YE": {
      "display": "Yemen",
      "userSelectable": true
    },
    "YT": {
      "display": "Mayotte",
      "userSelectable": true
    },
    "ZA": {
      "display": "South Africa",
      "userSelectable": true,
      "region": "foundation"
    },
    "ZM": {
      "display": "Zambia",
      "userSelectable": true
    },
    "ZW": {
      "display": "Zimbabwe",
      "userSelectable": true
    }
  },
  "eu": ["AT","BE","BG","CY","CZ","DE","DK","EE","ES","FI","FR","GB","GR","HR","HU","IE","IT","LT","LU","LV","MT","NL","PL","PT","RO","SE","SI","SK","UK"],
  "gdpr": ["AT","AX","BE","BG","BL","BR","BV","CE","CH","CY","CZ","DE","DK","EE","ES","EU","FI","FO","FR","GB","GF","GG","GI","GP","GR","HR","HU","IE","IM","IO","IS","IT","JE","KE","LI","LT","LU","LV","MC","MF","MQ","MS","MT","NC","NL","NO","PF","PL","PM","PT","RE","RO","SE","SI","SJ","SK","SM","TF","UK","VA","WF","YT", "ZA"],
  "staffed": ["AU","CA","US","VI","TR","DE","ES","FR","GB","IT","AR","CL","JP","CO","MX","BR","ID","IN","RU","TH","AD","ZA","PH","CH","NG"]
}
